const RoleListTableLangKey = [
	'column_id',
	'column_code',
	'column_name',
	'column_is_buyer',
	'column_in_group',
	'column_is_team',
	'column_team_report',
	'column_permissions',
	'column_is_system',
	'column_access',
] as const

type IRoleListTableLangKey = typeof RoleListTableLangKey[number]

export type IRoleListTableLang = {
	role_list_table: Record<IRoleListTableLangKey, string>
}

const langEntries = RoleListTableLangKey.map(
	(key: IRoleListTableLangKey) => [key, `role_list_table.${key}`]
)

const langObj: Record<IRoleListTableLangKey, string> = Object.fromEntries(langEntries)

export const ROLE_LIST_TABLE_LANG_KEY: IRoleListTableLang = {
	role_list_table: langObj
}
